import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {MdKeyboardArrowRight} from 'react-icons/md';
import {AiOutlineTwitter} from 'react-icons/ai';
import {BsFacebook} from 'react-icons/bs';
import {RiSendPlaneFill} from 'react-icons/ri';
import ReactPlayer from 'react-player';

import './virtualstart_styles/getstarted.css';

export default function StartGetStarted() {
  return (
    <>
      <Container className='mt-5 mb-5 start_getstarted'>
        <Row>
          <Col>
            <h3>Get Started</h3> 
          </Col>  
        </Row>  
        <Row>
          <Col lg={6} className='mt-3'>
          <div className='player-wrapper'>
        <ReactPlayer
          className='react-player'
          url='https://www.youtube.com/watch?v=ysz5S6PUM-U'
          width='100%'
          height='100%'
          controls={true}
          playing={false}
        />
      </div>
          </Col>
          <Col lg={6} className='ps-lg-5 start_gtst_col2 mt-3'>
            <div className="start_started_head mb-5">
              <div className="start_head_head d-flex align-items-center gap-5">
                <h3>Startup FAQ</h3>
                <span><a href="http://" target="_blank" rel="noopener noreferrer">More<MdKeyboardArrowRight /></a></span>
              </div>
              <div className='mt-3'>
                <a href='/'>Startup FAQ</a>
              </div>
              <div className='mt-3'>
                <a href='/'>Startup Participation Tutorial</a>
              </div>
              <div className='mt-3'>
                <a href='/'>Gate VIP Tiered Fee</a>
              </div>
            </div>
            <div className="head_started_icons d-flex align-items-center justify-content-evenly rounded">
              <div className="started_twi sta_ico">
                <span><AiOutlineTwitter /></span>
              </div>
              <div className="started_fb sta_ico">
                <span><BsFacebook /></span>
              </div>
              <div className="started_se sta_ico">
                <span><RiSendPlaneFill /></span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>    
    </>
  )
}